var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-with-main-container',{attrs:{"title":"Policies","has_content_header":false},scopedSlots:_vm._u([{key:"container-content",fn:function(){return [_c('security-policies')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }